const { REACT_APP_API_URL } = process.env;

const baseURL = REACT_APP_API_URL;

export const postsURL = baseURL + "/posts/";

export const postDetailsURL = (id) => baseURL + `/posts/${id}/`;

export const translatorURL = baseURL + "/translate/";
